export const SHOW_FILTERS_BUTTON_DATA_TEST_ID = 'show-filters-button';
export const FILTERS_COUNTER_DATA_TEST_ID = 'filters-counter';
